import { CustomTableGuard } from './custom-table.guard';

export const guards = [CustomTableGuard];

export * from './custom-table.guard';
